// User actions login
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
// logout
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
// change passeword
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';
//forgot password
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
// new password
export const NEW_PASSWORD = 'NEW_PASSWORD';
export const NEW_PASSWORD_SUCCESS = 'NEW_PASSWORD_SUCCESS';
export const NEW_PASSWORD_ERROR = 'NEW_PASSWORD_ERROR';

// Loader
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

// Theme
export const CHANGE_THEME = 'CHANGE_THEME';
export const EXPAND_COLLAPSE_DRAWER = 'EXPAND_COLLAPSE_DRAWER';

// Active Crops
export const ACTIVE_CROPS = 'ACTIVE_CROPS';
export const ACTIVE_CROPS_SUCCESS = 'ACTIVE_CROPS_SUCCESS';
export const ACTIVE_CROPS_ERROR = 'ACTIVE_CROPS_ERROR';

// Archived Crops
export const ARCHIVED_CROPS = 'ARCHIVED_CROPS';
export const ARCHIVED_CROPS_SUCCESS = 'ARCHIVED_CROPS_SUCCESS';
export const ARCHIVED_CROPS_ERROR = 'ARCHIVED_CROPS_ERROR';
export const ARCHIVED_CROPS_CURRENT_PAGE = 'ARCHIVED_CROPS_CURRENT_PAGE';

// Upload Image
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'UPLOAD_IMAGE_ERROR';

// Delete Image
export const DELETE_IMAGE = 'DELETE_IMAGE';
export const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS';
export const DELETE_IMAGE_ERROR = 'DELETE_IMAGE_ERROR';

//Language
export const GET_LANGUAGE = 'GET_LANGUAGE';
export const GET_LANGUAGE_SUCCESS = 'GET_LANGUAGE_SUCCESS';
export const GET_LANGUAGE_ERROR = 'GET_LANGUAGE_ERROR';

// Search term
export const SEARCH_TERM = 'SEARCH_TERM';

// Create Crop
export const CREATE_CROP = 'CREATE_CROP';
export const CREATE_CROP_SUCCESS = 'CREATE_CROP_SUCCESS';
export const CREATE_CROP_ERROR = 'CREATE_CROP_ERROR';

//crete issue
export const CREATE_ISSUE = 'CREATE_ISSUE';
export const CREATE_ISSUE_SUCCESS = 'CREATE_ISSUE_SUCCESS';
export const CREATE_ISSUE_ERROR = 'CREATE_ISSUE_ERROR';

// crop list
export const CROPS = 'CROPS';

// edit crop
export const FETCH_EDIT_CROP_INFO = 'FETCH_EDIT_CROP_INFO';
export const FETCH_EDIT_CROP_INFO_SUCCESS = 'FETCH_EDIT_CROP_INFO_SUCCESS';
export const FETCH_EDIT_CROP_INFO_ERROR = 'FETCH_EDIT_CROP_INFO_ERROR';

// Archive crop
export const ARCHIVE_ACTIVE_CROPS = 'ARCHIVE_ACTIVE_CROPS';
export const ARCHIVE_ACTIVE_CROPS_SUCCESS = 'ARCHIVE_ACTIVE_CROPS_SUCCESS';
export const ARCHIVE_ACTIVE_CROPS_ERROR = 'ARCHIVE_ACTIVE_CROPS_ERROR';

// Edit crop
export const EDIT_ACTIVE_CROP_SUCCESS = 'EDIT_ACTIVE_CROP_SUCCESS';
export const ADDED_CROP_NAME = 'ADDED_CROP_NAME';

//Active crop
export const ACTIVE_ARCHIVED_CROPS = 'ACTIVE_ARCHIVED_CROPS';
export const ACTIVE_ARCHIVED_CROPS_SUCCESS = 'ACTIVE_ARCHIVED_CROPS_SUCCESS';
export const ACTIVE_ARCHIVED_CROPS_ERROR = 'ACTIVE_ARCHIVED_CROPS_ERROR';

export const CLEAR_CROP_INFO = 'CLEAR_CROP_INFO';

// Active Segments
export const ACTIVE_SEGMENTS = 'ACTIVE_SEGMENTS';
export const ACTIVE_SEGMENTS_SUCCESS = 'ACTIVE_SEGMENTS_SUCCESS';
export const ACTIVE_SEGMENTS_ERROR = 'ACTIVE_SEGMENTS_ERROR';

// Archived Segments
export const ARCHIVED_SEGMENTS = 'ARCHIVED_SEGMENTS';
export const ARCHIVED_SEGMENTS_SUCCESS = 'ARCHIVED_SEGMENTS_SUCCESS';
export const ARCHIVED_SEGMENTS_ERROR = 'ARCHIVED_SEGMENTS_ERROR';
export const ARCHIVED_SEGMENT_CURRENT_PAGE = 'ARCHIVED_SEGMENT_CURRENT_PAGE';

// Archive Active Segment
export const ARCHIVE_ACTIVE_SEGMENT = 'ARCHIVE_ACTIVE_SEGMENT';
export const ARCHIVE_ACTIVE_SEGMENT_SUCCESS = 'ARCHIVE_ACTIVE_SEGMENT_SUCCESS';
export const ARCHIVE_ACTIVE_SEGMENT_ERROR = 'ARCHIVE_ACTIVE_SEGMENT_ERROR';

// Active Archived segment
export const ACTIVE_ARCHIVED_SEGMENT = 'ACTIVE_ARCHIVED_SEGMENT';
export const ACTIVE_ARCHIVED_SEGMENT_SUCCESS =
  'ACTIVE_ARCHIVED_SEGMENT_SUCCESS';
export const ACTIVE_ARCHIVED_SEGMENT_ERROR = 'ACTIVE_ARCHIVED_SEGMENT_ERROR';

// crop issues list
export const GET_CROP_ISSUES = 'GET_CROP_ISSUES';
export const GET_CROP_ISSUES_SUCCESS = 'GET_CROP_ISSUES_SUCCESS';
export const GET_CROP_ISSUES_ERROR = 'GET_CROP_ISSUES_ERROR';

// crop issue
export const GET_CROP_ISSUE = 'GET_CROP_ISSUE';
export const GET_CROP_ISSUE_SUCCESS = 'GET_CROP_ISSUE_SUCCESS';
export const GET_CROP_ISSUE_ERROR = 'GET_CROP_ISSUE_ERROR';

//archive/restore issues
export const MARK_CROP_ISSUE = 'MARK_CROP_ISSUES';
export const MARK_CROP_ISSUE_SUCCESS = 'MARK_CROP_ISSUES_SUCCESS';
export const MARK_CROP_ISSUE_ERROR = 'MARK_CROP_ISSUES_ERROR';

//edit crop issue
export const EDIT_CROP_ISSUE = 'EDIT_CROP_ISSUE';
export const EDIT_CROP_ISSUE_SUCCESS = 'EDIT_CROP_ISSUE_SUCCESS';
export const EDIT_CROP_ISSUE_ERROR = 'EDIT_CROP_ISSUE_ERROR';

// autocomplete segment list
export const FETCH_SEGMENT_LIST = 'FETCH_SEGMENT_LIST';
export const FETCH_SEGMENT_LIST_SUCCESS = 'FETCH_SEGMENT_LIST_SUCCESS';
export const FETCH_SEGMENT_LIST_ERROR = 'FETCH_SEGMENT_LIST_ERROR';

// create segment
export const CREATE_SEGMENT = 'CREATE_SEGMENT';
export const CREATE_SEGMENT_SUCCESS = 'CREATE_SEGMENT_SUCCESS';
export const CREATE_SEGMENT_ERROR = 'CREATE_SEGMENT_ERROR';

// ProductList
export const FETCH_PRODUCT_LIST = 'FETCH_PRODUCT_LIST';
export const FETCH_PRODUCT_LIST_SUCCESS = 'FETCH_PRODUCT_LIST_SUCCESS';
export const FETCH_PRODUCT_LIST_ERROR = 'FETCH_PRODUCT_LIST_ERROR';

// get segment (edit scenario)
export const GET_SEGMENT = 'GET_SEGMENT';
export const GET_SEGMENT_SUCCESS = 'GET_SEGMENT_SUCCESS';
export const GET_SEGMENT_ERROR = 'GET_SEGMENT_ERROR';

// edit segment
export const EDIT_SEGMENT = 'EDIT_SEGMENT';
export const EDIT_SEGMENT_SUCCESS = 'EDIT_SEGMENT_SUCCESS';
export const EDIT_SEGMENT_ERROR = 'EDIT_SEGMENT_ERROR';

// crop list
export const FETCH_CROPLIST = 'FETCH_CROPLIST';
export const FETCH_CROPLIST_SUCCESS = 'FETCH_CROPLIST_SUCCESS';
export const FETCH_CROPLIST_ERROR = 'FETCH_CROPLIST_ERROR';

// Edit crop
export const EDIT_CROP = 'EDIT_CROP';
export const EDIT_CROP_SUCCESS = 'EDIT_CROP_SUCCESS';
export const EDIT_CROP_ERROR = 'EDIT_CROP_ERROR';

// get crop
export const FETCH_CROP_INFO = 'FETCH_CROP_INFO';
export const FETCH_CROP_INFO_SUCCESS = 'FETCH_CROP_INFO_SUCCESS';
export const FETCH_CROP_INFO_ERROR = 'FETCH_CROP_INFO_ERROR';

// get crop stats
export const FETCH_CROP_STATS = 'FETCH_CROP_STATS';
export const FETCH_CROP_STATS_SUCCESS = 'FETCH_CROP_STATS_SUCCESS';
export const FETCH_CROP_STATS_ERROR = 'FETCH_CROP_STATS_ERROR';

// get schedule list for particular segment
export const FETCH_SCHEDULE_LIST = 'FETCH_SCHEDULE_LIST';
export const FETCH_SCHEDULE_LIST_SUCCESS = 'FETCH_SCHEDULE_LIST_SUCCESS';
export const FETCH_SCHEDULE_LIST_ERROR = 'FETCH_SCHEDULE_LIST_ERROR';

// create schedule
export const CREATE_POP_SCHEDULE = 'CREATE_POP_SCHEDULE';
export const CREATE_POP_SCHEDULE_SUCCESS = 'CREATE_POP_SCHEDULE_SUCCESS';
export const CREATE_POP_SCHEDULE_ERROR = 'CREATE_POP_SCHEDULE_ERROR';

// get schedule basic info
export const FETCH_SCHEDULE_INFO = 'FETCH_SCHEDULE_INFO';
export const FETCH_SCHEDULE_INFO_SUCCESS = 'FETCH_SCHEDULE_INFO_SUCCESS';
export const FETCH_SCHEDULE_INFO_ERROR = 'FETCH_SCHEDULE_INFO_ERROR';

// get schedule history
export const FETCH_SCHEDULE_HISTORY = 'FETCH_SCHEDULE_HISTORY';
export const FETCH_SCHEDULE_HISTORY_SUCCESS = 'FETCH_SCHEDULE_HISTORY_SUCCESS';
export const FETCH_SCHEDULE_HISTORY_ERROR = 'FETCH_SCHEDULE_HISTORY_ERROR';

// get all dropdowns
export const FETCH_SCHEDULE_DROPDOWN_DATA = 'FETCH_SCHEDULE_DROPDOWN_DATA';
export const FETCH_SCHEDULE_DROPDOWN_DATA_SUCCESS =
  'FETCH_SCHEDULE_DROPDOWN_DATA_SUCCESS';
export const FETCH_SCHEDULE_DROPDOWN_DATA_ERROR =
  'FETCH_SCHEDULE_DROPDOWN_DATA_ERROR';

// get regions
export const FETCH_REGION = 'FETCH_REGION';
export const FETCH_REGION_SUCCESS = 'FETCH_REGION_SUCCESS';
export const FETCH_REGION_ERROR = 'FETCH_REGION_ERROR';

// get schedule (read only)
export const FETCH_SCHEDULE = 'FETCH_SCHEDULE';
export const FETCH_SCHEDULE_SUCCESS = 'FETCH_SCHEDULE_SUCCESS';
export const FETCH_SCHEDULE_ERROR = 'FETCH_SCHEDULE_ERROR';

// save basic details
export const SAVE_BASIC_DETAILS = 'SAVE_BASIC_DETAILS';
export const SAVE_BASIC_DETAILS_SUCCESS = 'SAVE_BASIC_DETAILS_SUCCESS';
export const SAVE_BASIC_DETAILS_ERROR = 'SAVE_BASIC_DETAILS_ERROR';

// save sowing details
export const SAVE_SOWING_DETAILS = 'SAVE_SOWING_DETAILS';
export const SAVE_SOWING_DETAILS_SUCCESS = 'SAVE_SOWING_DETAILS_SUCCESS';
export const SAVE_SOWING_DETAILS_ERROR = 'SAVE_SOWING_DETAILS_ERROR';

// Create crop stages
export const CREATE_CROP_STAGE = 'CREATE_CROP_STAGE';
export const CREATE_CROP_STAGE_SUCCESS = 'CREATE_CROP_STAGE_SUCCESS';
export const CREATE_CROP_STAGE_ERROR = 'CREATE_CROP_STAGE_ERROR';

// Get crop stages
export const GET_CROP_STAGES = 'GET_CROP_STAGES';
export const GET_CROP_STAGES_SUCCESS = 'GET_CROP_STAGES_SUCCESS';
export const GET_CROP_STAGES_ERROR = 'GET_CROP_STAGES_ERROR';

// Delete crop stage
export const DELETE_CROP_STAGE = 'DELETE_CROP_STAGE';
export const DELETE_CROP_STAGE_SUCCESS = 'DELETE_CROP_STAGE_SUCCESS';
export const DELETE_CROP_STAGE_ERROR = 'DELETE_CROP_STAGE_ERROR';

// ACtive schedule
export const SCHEDULE_STATUS = 'SCHEDULE_STATUS';
export const SCHEDULE_STATUS_SUCCESS = 'SCHEDULE_STATUS_SUCCESS';
export const SCHEDULE_STATUS_ERROR = 'SCHEDULE_STATUS_ERROR';

// EDIT schedule name
export const EDIT_SCHEDULE_NAME = 'EDIT_SCHEDULE_NAME';
export const EDIT_SCHEDULE_NAME_SUCCESS = 'EDIT_SCHEDULE_NAME_SUCCESS';
export const EDIT_SCHEDULE_NAME_ERROR = 'EDIT_SCHEDULE_NAME_ERROR';

//Clear schedule info
export const CLEAR_SCHEDULE_INFO = 'CLEAR_SCHEDULE_INFO';

// save as draft
export const SAVE_SCHEDULE_AS_DRAFT = 'SAVE_SCHEDULE_AS_DRAFT';
export const SAVE_SCHEDULE_AS_DRAFT_SUCCESS = 'SAVE_SCHEDULE_AS_DRAFT_SUCCESS';
export const SAVE_SCHEDULE_AS_DRAFT_ERROR = 'SAVE_SCHEDULE_AS_DRAFT_ERROR';

// Tasks
export const GET_STAGE_TASKS = 'GET_STAGE_TASKS';
export const GET_STAGE_TASKS_SUCCESS = 'GET_STAGE_TASKS_SUCCESS';
export const GET_STAGE_TASKS_ERROR = 'GET_STAGE_TASKS_ERROR';
// get stage
export const GET_STAGE = 'GET_STAGE';
export const GET_STAGE_SUCCESS = 'GET_STAGE_SUCCESS';
export const GET_STAGE_ERROR = 'GET_STAGE_ERROR';
// edit Stage
export const EDIT_STAGE = 'EDIT_STAGE';
export const EDIT_STAGE_SUCCESS = 'EDIT_STAGE_SUCCESS';
export const EDIT_STAGE_ERROR = 'EDIT_STAGE_ERROR';

// get task types
export const GET_TASK_TYPES = 'GET_TASK_TYPES';
export const GET_TASK_TYPES_SUCCESS = 'GET_TASK_TYPES_SUCCESS';
export const GET_TASK_TYPES_ERROR = 'GET_TASK_TYPES_ERROR';

//create task
export const CREATE_STAGE_TASK = 'CREATE_STAGE_TASK';
export const CREATE_STAGE_TASK_SUCCESS = 'CREATE_STAGE_TASK_SUCCESS';
export const CREATE_STAGE_TASK_ERROR = 'CREATE_STAGE_TASK_ERROR';

// Delete task
export const DELETE_STAGE_TASK = 'DELETE_STAGE_TASK';
export const DELETE_STAGE_TASK_SUCCESS = 'DELETE_STAGE_TASK_SUCCESS';
export const DELETE_STAGE_TASK_ERROR = 'DELETE_STAGE_TASK_ERROR';
// toggle accordian
export const TOOGLE_ACCORDIAN = 'TOOGLE_ACCORDIAN';

// save task details
export const SAVE_TASK = 'SAVE_TASK';
export const SAVE_TASK_SUCCESS = 'SAVE_TASK_SUCCESS';
export const SAVE_TASK_ERROR = 'SAVE_TASK_ERROR';

export const SAVE_TASK_DETAILS = 'SAVE_TASK_DETAILS';
export const SAVE_TASK_DETAILS_SUCCESS = 'SAVE_TASK_DETAILS_SUCCESS';
export const SAVE_TASK_DETAILS_ERROR = 'SAVE_TASK_DETAILS_ERROR';

// get task details
export const GET_TASK_DETAILS = 'GET_TASK_DETAILS';
export const GET_TASK_DETAILS_SUCCESS = 'GET_TASK_DETAILS_SUCCESS';
export const GET_TASK_DETAILS_ERROR = 'GET_TASK_DETAILS_ERROR';

// SMS actions
export const CREATE_SMS_ENTITY = 'CREATE_SMS_ENTITY';
export const CREATE_SMS_ENTITY_SUCCESS = 'CREATE_SMS_ENTITY_SUCCESS';
export const CREATE_SMS_ENTITY_ERROR = 'CREATE_SMS_ENTITY_ERROR';

export const SAVE_SMS = 'SAVE_SMS';
export const SAVE_SMS_SUCCESS = 'SAVE_SMS_SUCCESS';
export const SAVE_SMS_ERROR = 'SAVE_SMS_ERROR';

export const GET_SMS_LIST = 'GET_SMS_LIST';
export const GET_SMS_LIST_SUCCESS = 'GET_SMS_LIST_SUCCESS';
export const GET_SMS_LIST_ERROR = 'GET_SMS_LIST_ERROR';

export const DELETE_SMS = 'DELETE_SMS';
export const DELETE_SMS_SUCCESS = 'DELETE_SMS_SUCCESS';
export const DELETE_SMS_ERROR = 'DELETE_SMS_ERROR';

export const EDIT_SMS = 'EDIT_SMS';
export const EDIT_SMS_SUCCESS = 'EDIT_SMS_SUCCESS';
export const EDIT_SMS_ERROR = 'EDIT_SMS_ERROR';
// get units
export const GET_UNITS = 'GET_UNITS';
export const GET_UNITS_SUCCESS = 'GET_UNITS_SUCCESS';
export const GET_UNITS_ERROR = 'GET_UNITS_ERROR';

// get alternate products
export const FETCH_ALTERNATE_PRODUCTS = 'FETCH_ALTERNATE_PRODUCTS';
export const FETCH_ALTERNATE_PRODUCTS_SUCCESS =
  'FETCH_ALTERNATE_PRODUCTS_SUCCESS';
export const FETCH_ALTERNATE_PRODUCTS_ERROR = 'FETCH_ALTERNATE_PRODUCTS_ERROR';

// active schedule
export const CHANGE_SCHEDULE_STATUS = 'CHANGE_SCHEDULE_STATUS';
export const CHANGE_SCHEDULE_STATUS_SUCCESS = 'CHANGE_SCHEDULE_STATUS_SUCCESS';
export const CHANGE_SCHEDULE_STATUS_ERROR = 'CHANGE_SCHEDULE_STATUS_ERROR';

// create stage issue
export const CREATE_STAGE_ISSUE = 'CREATE_STAGE_ISSUE';
export const CREATE_STAGE_ISSUE_SUCCESS = 'CREATE_STAGE_ISSUE_SUCCESS';
export const CREATE_STAGE_ISSUE_ERROR = 'CREATE_STAGE_ISSUE_ERROR';

// get stage issue
export const GET_STAGE_ISSUES = 'GET_STAGE_ISSUES';
export const GET_STAGE_ISSUES_SUCCESS = 'GET_STAGE_ISSUES_SUCCESS';
export const GET_STAGE_ISSUES_ERROR = 'GET_STAGE_ISSUES_ERROR';

// delete stage issue
export const DELETE_STAGE_ISSUE = 'DELETE_STAGE_ISSUE';
export const DELETE_STAGE_ISSUE_SUCCESS = 'DELETE_STAGE_ISSUE_SUCCESS';
export const DELETE_STAGE_ISSUE_ERROR = 'DELETE_STAGE_ISSUE_ERROR';

// save stage issue
export const SAVE_STAGE_ISSUE = 'SAVE_STAGE_ISSUE';
export const SAVE_STAGE_ISSUE_SUCCESS = 'SAVE_STAGE_ISSUE_SUCCESS';
export const SAVE_STAGE_ISSUE_ERROR = 'SAVE_STAGE_ISSUE_ERROR';

// get stage issue details
export const GET_STAGE_ISSUE_DETAILS = 'GET_STAGE_ISSUE_DETAILS';
export const GET_STAGE_ISSUE_DETAILS_SUCCESS =
  'GET_STAGE_ISSUE_DETAILS_SUCCESS';
export const GET_STAGE_ISSUE_DETAILS_ERROR = 'GET_STAGE_ISSUE_DETAILS_ERROR';

// issue list dropdown
export const GET_CROP_ISSUES_LIST = 'GET_CROP_ISSUES_LIST';
export const GET_CROP_ISSUES_LIST_SUCCESS = 'GET_CROP_ISSUES_LIST_SUCCESS';
export const GET_CROP_ISSUES_LIST_ERROR = 'GET_CROP_ISSUES_LIST_ERROR';

// pop schdedule validation
export const GET_POP_SCHEDULE_VALIDATION = 'GET_POP_SCHEDULE_VALIDATION';
export const GET_POP_SCHEDULE_VALIDATION_SUCCESS =
  'GET_POP_SCHEDULE_VALIDATION_SUCCESS';
export const GET_POP_SCHEDULE_VALIDATION_ERROR =
  'GET_POP_SCHEDULE_VALIDATION_ERROR';

// clear data
export const CLEAR_DATA = 'CLEAR_DATA';
export const UNLOAD_TASK_DETAILS = 'UNLOAD_TASK_DETAILS';
export const UNLOAD_ISSUE_DETAILS = 'UNLOAD_ISSUE_DETAILS';
export const UNLOAD_PRODUCTS = 'UNLOAD_PRODUCTS';
export const UNLOAD_STATE = 'UNLOAD_STATE';
export const UNLOAD_DISTRICT = 'UNLOAD_DISTRICT';
export const UNLOAD_TALUKA = 'UNLOAD_TALUKA';
